import { render, staticRenderFns } from "./MatchAttachments.vue?vue&type=template&id=3147b8de&"
import script from "./MatchAttachments.vue?vue&type=script&lang=js&"
export * from "./MatchAttachments.vue?vue&type=script&lang=js&"
import style0 from "./MatchAttachments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports